import { render, staticRenderFns } from "./FileCompare.vue?vue&type=template&id=af361756"
import script from "./FileCompare.vue?vue&type=script&lang=js"
export * from "./FileCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports